export { default as MedicalSchools } from './MedicalSchools';
